import { Component } from "@angular/core";

import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-master-admin",
	templateUrl: "./master-admin.component.html",
	styleUrls: ["./master-admin.component.scss"]
})
export class MasterAdminComponent {
	public calcStatus: string;
	public calcProgress: number;

	constructor(public api: ApiService) { }

	public async RecalculateStates() {
		const result = await this.api.RecalculateStates(true);
		const taskId = result.task;
		await this.api.PollTaskToCompletion(taskId, (status, progress) => {
			this.calcStatus = status;
			this.calcProgress = progress;
		});
	}
}
